<!-- 已发短信查询 -->
<template>
  <div class='forecastSms'>
    <div class="sms_top">
        <div class="select">
          <span class="desc">起止时间:</span>
          <div class="block" style="display: inline-block;">
            <el-date-picker
              v-model="selecttime1"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始日期时间"
              :picker-options="Global.pickerOptionsStart(selecttime2)"
              default-time="08:00:00"
              :clearable="false"
              :editable="false"
              >
            </el-date-picker>
            <span style="margin:0 5px;">至</span>
            <el-date-picker
              v-model="selecttime2"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择结束日期时间"
              :picker-options="Global.pickerOptionsEnd(selecttime1)"
              default-time="08:00:00"
              :clearable="false"
              :editable="false">
            </el-date-picker>
          </div>
        </div>
        <el-button id="search" @click="getAllData" type="primary" size="small" title="查询">查询</el-button>

    </div>
    <div class="sms_bottom" ref="sms_bottom">
      <el-table
        v-loading="loading"
        :data="tableData"
        :max-height="height"
        border
        @selection-change="handleCurrentChange"
      >
        <el-table-column fixed type="index" width="70" label="序号" align="center" header-align="center">
           <template slot-scope="scope">
              <span>{{pageSize * (pageIndex-1) + scope.$index+1}}</span>
            </template>
        </el-table-column>
        <el-table-column  prop="receptnm" align="left" header-align="left" label="姓名" min-width="20">
        </el-table-column>
        <el-table-column  prop="unit" align="left" header-align="left" label="单位" min-width="40">
        </el-table-column>
        <el-table-column  prop="position" align="left" header-align="left" label="职务" min-width="30">
        </el-table-column>
        <el-table-column  prop="msgType" align="left" header-align="left" label="短信类型" min-width="30">
        </el-table-column>
        <el-table-column  prop="townName" align="left" header-align="left" label="乡镇" min-width="30">
        </el-table-column>
        <el-table-column prop="naturalAdnm" align="left" header-align="left" label="预警名称" min-width="80">
        </el-table-column>
        <el-table-column prop="msgContent" align="left" header-align="left" label="消息内容" min-width="150">
        </el-table-column>
        <el-table-column prop="sendTime" align="center" header-align="center" label="发送时间" min-width="70">
        </el-table-column>
        <el-table-column prop="isSuccessStatus" align="center" header-align="center" label="是否发送成功" min-width="30">
        </el-table-column>
      </el-table>
       <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
    </div>
    <!-- 查看详情 -->
    <el-dialog
      class="abow_dialog"
      title="已发短信详情"
      width="70%"
      :close-on-click-modal="false"
      :visible.sync="smsDetailsDialog">
      <div class="smsDetailFilter">
        <el-form ref="groupForm" :model="mobileForm" label-width="110px" label-height="40px">
          <el-form-item label="乡镇/单位:">
            <el-input v-model="deptName" clearable @change="Global.emptyQuery(deptName, getCheckDataSearch)"></el-input>
          </el-form-item>
          <el-form-item label="姓名:">
            <el-input v-model="personName" clearable @change="Global.emptyQuery(personName, getCheckDataSearch)"></el-input>
          </el-form-item>
          <el-form-item label="手机:">
            <el-input v-model="sPHONE" clearable @change="Global.emptyQuery(sPHONE, getCheckDataSearch)"></el-input>
          </el-form-item>
        </el-form>
        <el-button id="search" @click="getCheckDataSearch" type="primary" size="small" title="查询">查询</el-button>
        <el-button id="exportData" @click="exportCheckData" type="primary" size="small" title="导出">导出</el-button>
      </div>
      <div class="smsDetailTab">
        <el-table :data="detailTableData" :max-height="height" border empty-text="-" style="width: 100%;" v-loading="loading">
          <el-table-column fixed :index='(index)=>{return (index+1) + (cpageIndex-1)*cpageSize }' type="index" width="70" label="序号" align="center" header-align="center">
          </el-table-column>
          <el-table-column  prop="personName" align="left" header-align="left" label="姓名" min-width="70">
          </el-table-column>
          <el-table-column prop="deptName" align="left" header-align="left" label="单位" min-width="90">
          </el-table-column>
          <el-table-column prop="warnNM" align="left" header-align="left" label="预警名称" min-width="90">
          </el-table-column>
          <el-table-column prop="smstxt" align="left" header-align="left" label="消息内容" min-width="250">
          </el-table-column>
          <el-table-column prop="stime" align="center" header-align="center" label="发送时间" min-width="120">
          </el-table-column>
          <el-table-column prop="sresult" align="left" header-align="left" label="是否发送成功" min-width="90">
          </el-table-column>
        </el-table>
         <!-- 添加分页 -->
        <el-pagination
          @size-change="handleSizeChangeDialog"
          @current-change="handleCurrentChangeDialog"
          :current-page="cpageIndex"
          :page-sizes="[20, 50, 100]"
          :page-size="cpageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ctotal">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import warnTypes from '@/store/types/warningcenter'
import api from '@/api/warningcenter'
import timer from '@/utils/timer'
import config from '@/config'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      loading: false,
      timerFun: '',
      activeName: 'mobile',
      smsDetailsDialog: false,
      smsDetailsDialogData: {},
      height: 10,
      sentType: [
        { value: '全部',
          label: '全部'
        }, {
          value: '手动',
          label: '手动'
        }, {
          value: '自动',
          label: '自动'
        }
      ],
      selecttime: '',
      selecttime1: '',
      selecttime2: '',
      tableData: [],
      mobileForm: {},
      detailTableData: [],
      warnNM: '',
      msgType: '',
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      warnID: '',
      deptName: '',
      personName: '',
      sPHONE: '',
      smsTotal: 0,
      totalnum: 0,
      cpageIndex: 1, // 短信详情分页
      cpageSize: 20,
      ctotal: 0,
      resetMessageDialog: false,
      resendMessageTxt: '',
      status: '重发',
      selectedRows: [],
      textarea: '' // 当前所发短信内容
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    exportData() {
      api.sendMessageExport({
        warnNM: this.warnNM,
        msgType: this.msgType,
        messageSendETM: this.selecttime2 + ':59',
        messageSendSTM: this.selecttime1
      }).then(res => {
        window.open(config.ApiYJ + res.data.data)
      })
    },
    exportCheckData() {
      api.sendMessageQueryLiablePersonExport({
        id: this.warnID,
        deptName: this.deptName,
        personName: this.personName,
        phone: this.sPHONE
      }).then(res => {
        window.open(config.ApiYJ + res.data.data)
      })
    },
    handleSizeChange (val) {
      this.pageIndex = 1
      this.pageSize = val
      this.getAllData()
    },
    handleCurrentChange (val) {
      this.pageIndex = val
      this.getAllData()
    },
    getAllDataSearch () {
      this.pageIndex = 1 // 查询重置页码
      this.getAllData()
    },
    // 点击查看
    handleClick (row) {
      this.smsDetailsDialog = true
      this.cpageIndex = 1
      this.warnID = row.id
      this.getCheckData()
    },
    // 查询点击查看时的数据
    getCheckData () {
      this.loading = true
      this.$store.dispatch(warnTypes.GET_SENDMESSAGE_QUERY_LIABLEPERSON, {
        ID: this.warnID,
        deptName: this.deptName,
        personName: this.personName,
        sPHONE: this.sPHONE,
        pageIndex: this.cpageIndex,
        pageSize: this.cpageSize
      }).then(data => {
        this.detailTableData = data.results
        this.selectedRows = data.results // 重发查看
        this.ctotal = data.total
        this.loading = false
      })
    },
    // 查看短信详情分页
    handleSizeChangeDialog (val) {
      this.cpageIndex = 1
      this.cpageSize = val
      this.getCheckData()
    },
    handleCurrentChangeDialog (val) {
      this.cpageIndex = val
      this.getCheckData()
    },
    getCheckDataSearch () {
      this.cpageIndex = 1 // 查询重置页码
      this.getCheckData()
    },
    // handleCurrentChange (val) {
    //   this.currentRow = val
    // },
    gettime: function () {
      let date = new Date()
      let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      if (date.getHours() >= 8) {
        this.selecttime1 = date.getFullYear() + '-' + month + '-' + day + ' 08:00'
        this.selecttime2 = date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes()
      } else {
        let day = date.getDate() - 1 < 10 ? '0' + (date.getDate() - 1) : (date.getDate() - 1)
        this.selecttime1 = date.getFullYear() + '-' + month + '-' + day + ' ' + date.getHours() + ':' + date.getMinutes()
        this.selecttime2 = date.getFullYear() + '-' + month + '-' + day + ' 08:00'
      }
    },
    getAllData () {
      this.loading = true
      this.$store.dispatch(warnTypes.GET_PROXY_LIST_FORECAST_MESSAGE_DETAIL, {
        messageSendETM: this.selecttime2 + ':59',
        messageSendSTM: this.selecttime1,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize
      }).then(data => {
        // debugger
        this.tableData = data.message.rows
        this.loading = false
        this.total = data.message.total
      })
    },
    // 设置默认起止时间
    setDefaultTime () {
      var date = new Date()
      var minDate = date.getTime() - 30 * 3600 * 1000 * 24
      this.selecttime2 = this.$moment(date).format('YYYY-MM-DD HH:mm')
      this.selecttime1 = this.$moment(minDate).format('YYYY-MM-DD 00:00')
    },
    // 短信重新重发编辑
    resendMessageEdit (row) {
      this.status = row.warnNM ? row.warnNM : '重发'
      this.textarea = row.smstxt
      this.resetMessageDialog = true
      this.warnID = row.id
      this.getCheckData()
    },
    // 重发短信发送
    sendResendMessage () {
      let sendPersonList = []
      this.selectedRows.forEach(item => {
        sendPersonList.push({ 'PersonPhone': item.sphone, 'PersonName': item.personName, 'AdcdCode': '' })
      })
      if (this.resendMessageTxt === '' || this.resendMessageTxt === undefined) {
        this.$notify.error({
          message: '短信内容不能为空'
        })
        return false
      }
      this.$store.dispatch(warnTypes.SENG_MESSAGE, { sendPersonList: sendPersonList, sendTxt: this.resendMessageTxt }).then(data => {
        this.resetMessageDialog = false
        if (data.isSuccess === true) {
          this.$notify({
            message: '您已成功重新发送短信',
            type: 'success'
          })
        } else {
          this.$notify.error({
            message: data.errorMsg
          })
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // this.gettime()
    this.setDefaultTime()
    this.getAllData()
    this.timerFun = setInterval(() => {
      // this.gettime()
      this.setDefaultTime()
      this.getAllData()
    }, timer.TIMER_MIN)
    this.$nextTick(() => {
      let forecastSmsDiv = document.getElementsByClassName('forecastSms')
      let smsTopDiv = document.getElementsByClassName('sms_top')
      this.$refs['sms_bottom'].style.height = (forecastSmsDiv[0].offsetHeight - smsTopDiv[0].offsetHeight - 45) + 'px'
      this.height = this.$refs['sms_bottom'].offsetHeight - 55
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    clearInterval(this.timerFun)
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="less" src="@/assets/warningcenter.less" scoped></style>
<style lang="less" scoped>
    /* 外层样式 */
    .forecastSms{
        width: 100%;
        padding: 15Px;
        height: 100%;
        position: relative;
        // top: -80px;
        /deep/ .el-table th {
          background: #F5F7FA!important;
        }
        /deep/ .el-dialog__body{
          padding: 15px;
        }
    }
    /* top */
    .sms_top{
        width: 100%;
        height: 80px;
        margin-bottom: 15Px;
        padding:15px;
        background: #ffffff;
    }
    .sms_top .select .desc{
        width: 80px;
        height: 35px;
        float: left;
        font-size:16px;
        font-family:Microsoft YaHei UI;
        line-height: 40px;
    }
    .sms_top .select{
        width: 560px;
        height: 35px;
        float: left;
    }
    .sentType{
        width: 325px;
        float: left;
    }
    .sentType .fsfs{
        width: 80px;
        height: 35px;
        float: left;
        font-size:16px;
        font-family:Microsoft YaHei UI;
        line-height: 40px;
    }
    .sentType .selectContent{
        width: 225px;
        float: left;
    }
    .sms_top #search,.sms_top #exportData{
        width: 75px;
        height: 38px;
        float: left;
        margin-left: 10px;
        background: #1d8af8;
        border: 0.03125rem solid #1d8af8;
        color: #fff;
        text-align: center;
        font-size: 16px;
        line-height: 20px;
        border-radius: 5px;
        cursor: pointer;
    }
    /* bottom */
    .sms_bottom{
      width: 100%;
      height: 100%;
      background-color: #fff;
      border-radius: 5px;
      padding-top: 15Px;
      padding-bottom: 15Px;
      > div {
        width: 98%;
        margin-left: 1%;
      }
    }
    /* 查看弹窗 */
    .abow_dialog {
      display: flex;
      justify-content: center;
      align-items: Center;
      overflow: hidden;
      /deep/ .el-dialog{
        margin-top: 0 !important;
         min-height: 400px;
      }
    }
    .abow_dialog .el-dialog__header{
      border-bottom: 1px solid #cccccc
    }
    .abow_dialog .smsDetailFilter{
      width: 100%;
      height: 45px;
      display: flex;
    }
    .abow_dialog .smsDetailFilter .el-form{
      // width: 710px;
      height: 45px;
      // float: left;
       display: flex;
    }
    .abow_dialog .smsDetailFilter .el-button{
      width: 75px;
      height: 38px;
      // float: left;
      margin-left: 10px;
      background: #1d8af8;
      border: 0.03125rem solid #1d8af8;
      color: #fff;
      text-align: center;
      font-size: 16px;
      line-height: 20px;
      border-radius: 5px;
      cursor: pointer;
    }
    .abow_dialog .el-form-item{
      // margin-right: 20px;
      display: inline-block;
      margin-left: 0;
      margin-bottom: 5px;
       /deep/ .el-form-item__label {
        width: 60px !important;
      }
      /deep/ .el-form-item__content {
          margin-left: 60px !important;
      }
    }
    .abow_dialog /deep/ .el-form-item:nth-child(1){
      width: 250px;
      height: 40px;
       /deep/ .el-form-item__label {
        width: 130px !important;
    }
      /deep/ .el-form-item__content {
        margin-left: 130px !important;
    }
    }
    .abow_dialog /deep/ .el-form-item:nth-child(2){
      width: 230px;
      height: 40px;
      // label{
      //   width: 50px !important;
      // }
      // .el-form-item__content{
      //   margin-left: 50px !important;
      // }
    }
    .abow_dialog /deep/ .el-form-item:nth-child(3){
      width: 230px;
      height: 40px;
      // label{
      //   width: 50px !important;
      // }
      // .el-form-item__content{
      //   margin-left: 50px !important;
      // }
    }
    .abow_dialog .el-form-item__label {
      width: 100px;
    }
    /* led */
    .abow_dialog .led .smsDetailFilter .el-form{
      width: 30%;
    }
    .numDiv{
      padding-left: 20px;
      line-height: 40px;
      float: left;
    }
      /* 短信重发弹框样式 */
  .abow_dialog_resend .el-form-item {
    float: left;
  }
  .abow_dialog_resend .el-form-item:nth-child(1) {
    width: 170px;
    height: 45px;
  }
  .abow_dialog_resend .el-form-item:nth-child(2) {
    width: 75%;
    margin-left: -90px;
  }
  .legend {
    width: auto;
    margin-bottom: 0;
    padding: 0 10px;
    border: none;
    color: #6a9bf3;
    font: 500 18px 'Microsoft YaHei UI';
  }
  .currentMessage {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    margin-top: 10px;
     div.messageTitle {
      width: 100px;
      font-weight: bold;
      white-space: nowrap;
      font-size: 16px;
      margin-right: 5px;
    }
    div.messageWrapper {
      width: calc(100% - 90px);
      /deep/ .el-textarea {
        width: 100%;
      }
       /deep/ .el-textarea.is-disabled .el-textarea__inner {
        border-color: #E4E7ED !important;
        color: #666;
        cursor: not-allowed !important;
    }
    }
  }
</style>
